// Helper to parse currency values robustly
// Handles "14000.00" (standard), "14.000,00" (Euro), "1,000.00" (US sometimes), "1.000.000" (Large Euro)
export const parseMontant = (mnt) => {
    if (mnt === null || mnt === undefined || mnt === '') return 0;
    if (typeof mnt === 'number') return mnt;
    if (typeof mnt === 'string') {
        const cleanStr = mnt.trim();

        const hasComma = cleanStr.includes(',');
        const hasDot = cleanStr.includes('.');

        // Case 1: Both separators present. The LAST one is the decimal separator.
        if (hasComma && hasDot) {
            const lastComma = cleanStr.lastIndexOf(',');
            const lastDot = cleanStr.lastIndexOf('.');

            if (lastComma > lastDot) {
                // Format: 14.500,00 (EU/DZ) -> Remove dots, replace comma with dot
                return parseFloat(cleanStr.replace(/\./g, '').replace(',', '.')) || 0;
            } else {
                // Format: 14,500.00 (US) -> Remove commas
                return parseFloat(cleanStr.replace(/,/g, '')) || 0;
            }
        }

        // Case 2: Only Comma. Treat as decimal separator (EU/DZ standard 100,50)
        if (hasComma) {
            return parseFloat(cleanStr.replace(/\./g, '').replace(',', '.')) || 0;
        }

        // Case 3: Only Dot.
        // If multiple dots (1.000.000), it's thousands.
        // If one dot, check context.
        const dotCount = (cleanStr.match(/\./g) || []).length;
        if (dotCount > 1) {
            return parseFloat(cleanStr.replace(/\./g, '')) || 0;
        }

        // Single dot ambiguity: "14.500" vs "14.50"
        // If followed by exactly 3 digits and end of string, assume thousands separator (DZD context)
        if (dotCount === 1) {
            if (/^\d+\.\d{3}$/.test(cleanStr)) {
                return parseFloat(cleanStr.replace(/\./g, '')) || 0;
            }
        }

        // Default: Treat dot as decimal (Standard float)
        return parseFloat(cleanStr) || 0;
    }
    return 0;
};

// Utility to format numbers as 12.000,00
export const formatMontant = (mnt) => {
    try {
        const val = parseMontant(mnt);
        if (isNaN(val)) return "0,00";
        // Use German locale which uses . for thousands and , for decimals
        return new Intl.NumberFormat('fr-DZ', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(val);
    } catch (e) {
        return "0,00";
    }
};

// Also keep a display helper if needed specifically with DZD
export const formatCurrency = (v) => {
    return formatMontant(v) + ' DZD';
};
